import React, { useState, useEffect } from 'react';
import './UploadScreen.css';
import {
  Warning,
  Close,
  CloudUpload
} from '@mui/icons-material';

function UploadScreen({ onComplete }) {
  const [showWarning, setShowWarning] = useState(true);
  const [timeRemaining, setTimeRemaining] = useState(10);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!showWarning) return;
    
    const interval = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 60000);

    return () => clearInterval(interval);
  }, [showWarning]);

  useEffect(() => {
    // Simulate upload progress
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          // Wait a bit at 100% then call onComplete
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 300);
          return 100;
        }
        // Increment by random amount to simulate realistic progress
        const increment = Math.random() * 15 + 5;
        return Math.min(prev + increment, 100);
      });
    }, 300); // Update every 300ms

    return () => clearInterval(progressInterval);
  }, [onComplete]);

  return (
    <div className="upload-screen-container">
      <div className="upload-screen-modal">
        {showWarning && (
          <div className="upload-warning-banner">
            <Warning className="warning-icon" />
            <span className="warning-text">
              For security reasons this session will expire in {timeRemaining} minutes.
            </span>
            <button
              className="warning-close"
              onClick={() => setShowWarning(false)}
            >
              <Close className="close-icon" />
            </button>
          </div>
        )}

        <div className="upload-content">
          <div className="upload-icon-wrapper">
            <CloudUpload className="upload-icon" />
          </div>

          <p className="upload-message">
            Please don't close this window until we've uploaded your passport. This usually takes less than a minute.
          </p>

          <div className="upload-progress-container">
            <div 
              className="upload-progress-bar"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploadScreen;
